import Box from "ds/components/Box";
import DraggableItemHandle from "ds/components/DraggableItem/Handle";

import { DragDropListItemDefaultProps } from "./types";

const DragDropListDefaultItem = ({
  children,
  dragging,
  handleRef,
  handleListeners,
  handleAttributes,
  titleComponent,
  disabled,
}: DragDropListItemDefaultProps) => {
  return (
    <Box justify="between" fullWidth direction="column">
      <Box align="center" gap="medium">
        <DraggableItemHandle
          dragging={dragging}
          variant="p-t6"
          ref={handleRef}
          handleListeners={handleListeners}
          handleAttributes={handleAttributes}
          disabled={disabled}
        />
        {titleComponent}
      </Box>
      {children && (
        <Box padding="large 0 0 0" fullWidth>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default DragDropListDefaultItem;
